import { render, staticRenderFns } from "./SelectPaymentChannel.vue?vue&type=template&id=bb764f1c&"
import script from "./SelectPaymentChannel.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports